import React, { useEffect, useState } from 'react';
import FeedbackSection from '../components/layout/hakkimizda/FeedbackSection';
import ContactStrip from '../components/common/ContactStrip';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import { toUrl } from '../lib/config';

const IletisimPage: React.FC = () => {

  const DEFAULT_HERO = {
    kicker: 'Bize ulaşın',
    title: 'İletişim',
    description: 'Megapark Hastanesi, her an ve her zaman sizin yanınızda. Sağlığınız bizim için en değerli önceliktir. Uzman hekim kadromuz, modern teknolojilerle donatılmış altyapımız ve güler yüzlü sağlık personelimiz ile günün her saati yanınızdayız.'
  };
  const [heroKicker, setHeroKicker] = useState<string>('');
  const [heroTitle, setHeroTitle] = useState<string>('');
  const [heroDesc, setHeroDesc] = React.useState<string>('');

  // FeedbackSection state
  const DEFAULT_FB = {
    titleLight: 'Görüşlerinizi',
    titleAccent: 'Bize Bildirin',
    description: 'Sizin görüşleriniz bizim için çok önemli. Görüşlerinizi, istek, dilek ve şikayetlerinizi bizimle paylaşın. Sizin memnuniyetiniz öncelikli görevimizdir.'
  };
  const [fbTitleLight, setFbTitleLight] = React.useState<string>('');
  const [fbTitleAccent, setFbTitleAccent] = React.useState<string>('');
  const [fbDescription, setFbDescription] = React.useState<string>('');

  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/page-hero/iletisim'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setHeroKicker((obj.kicker || '').trim());
        setHeroTitle((obj.title || '').trim());
        setHeroDesc((obj.description || '').trim());
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  // Fetch FeedbackSection content
  useEffect(() => {
    let cancelled = false;
    const run = async () => {
      try {
        const res = await fetch(toUrl('/api/feedback-section'));
        if (!res.ok) throw new Error('fetch_failed');
        const data = await res.json();
        const obj = Array.isArray(data) ? (data[0] || {}) : (data || {});
        if (cancelled) return;
        setFbTitleLight(obj.titleLight || '');
        setFbTitleAccent(obj.titleAccent || '');
        setFbDescription(obj.description || '');
      } catch {
        // keep defaults
      }
    };
    run();
    return () => { cancelled = true; };
  }, []);

  const SendFeedback = async (data: any) => {
      try {
        const payload = {
          name: data?.name ?? '',
          email: data?.email ?? '',
          subject: data?.subject ?? '',
          message: data?.message ?? '',
        };
        const res = await fetch(toUrl('/api/feedback-messages'), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(payload),
        });
        if (!res.ok) throw new Error('submit_failed');
        // İstersen burada başarı geri bildirimi verebilirsin
        console.log('Feedback gönderildi:', payload);
      } catch (e) {
        console.error('Feedback gönderilemedi', e);
      }
    }

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker={heroKicker || DEFAULT_HERO.kicker}
        title={heroTitle || DEFAULT_HERO.title}
        description={heroDesc || DEFAULT_HERO.description}
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#2b2b2b"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
       <FeedbackSection
        titleLight={fbTitleLight || DEFAULT_FB.titleLight}
        titleAccent={fbTitleAccent || DEFAULT_FB.titleAccent}
        description={fbDescription || DEFAULT_FB.description}
        // mapSrc="https://www.google.com/maps?q=%C3%96zel%20MegaPark%20Hastanesi%2C%20Dulkadiro%C4%9Flu%2C%20Kahramanmara%C5%9F&hl=tr&z=16&output=embed" // kendi embed URL'inizi koyun
        mapSrc='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3162.3583965308617!2d36.9591286!3d37.5701775!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x152de786eb8c813f%3A0xae5e14dbc0c189d6!2s%C3%96zel%20MegaPark%20Hastanesi!5e0!3m2!1str!2str!4v1759780781173!5m2!1str!2str'
        onSubmit={(data: any) => SendFeedback(data)}
        accentColor="#2cadd2"  // istersen tema rengi değiştir
        maxWidth={1200}
      />


      <ContactStrip  />
    </>
  );
};

export default IletisimPage;
